
import { createServiceClient } from 'utils/apiClient';


const clientClient = createServiceClient('/client');

export default clientClient;
